import {Component, Input} from '@angular/core';
import {DELIVERY_EXPENSES, FREE_DELIVERY_THRESHOLD} from "../../services/util/constants";

/**
 * "Уште X ден. до бесплатна достава" with a progress bar. Showing how little is missing
 * nudges buyers to add one more product rather than pay for delivery.
 */
@Component({
    selector: 'app-free-delivery-progress',
    standalone: true,
    template: `
        @if (remaining > 0) {
            <div class="text-left">
                <p class="text-sm text-gray-800">
                    Уште <strong>{{ remaining }} ден.</strong> до <strong>бесплатна достава</strong>
                </p>
                <div class="mt-1.5 h-2 w-full rounded-full bg-gray-200 overflow-hidden"
                     role="progressbar" aria-label="До бесплатна достава"
                     [attr.aria-valuenow]="progress" aria-valuemin="0" aria-valuemax="100">
                    <div class="h-full rounded-full bg-primary transition-all duration-300" [style.width.%]="progress"></div>
                </div>
                <p class="mt-1.5 text-xs text-gray-500">Достава: {{ deliveryFee }} ден.</p>
            </div>
        } @else {
            <p class="text-left text-sm font-medium text-green-700">✓ Имате бесплатна достава</p>
        }
    `
})
export class FreeDeliveryProgressComponent {

    /** Products total, without delivery. */
    @Input() orderPrice: number = 0;

    readonly deliveryFee = DELIVERY_EXPENSES;

    get remaining(): number {
        return Math.max(Math.ceil(FREE_DELIVERY_THRESHOLD - (this.orderPrice || 0)), 0);
    }

    get progress(): number {
        return Math.min(Math.round(((this.orderPrice || 0) / FREE_DELIVERY_THRESHOLD) * 100), 100);
    }
}
